// summaryPrompt.js — what auto-summary asks: always in the Summary app, and in
// the Chat tab when the clinician's Auto-summary switch is on. Summary is the
// Chat tab's own component and thread (components/Misc/Chat.js); chat already
// sees prior visits, this visit's transcript and notes, and connected-app data
// from this visit and earlier ones, so the brief needs nothing chat doesn't have.
const OPENER = 'Brief me on ';

export function summaryPrompt(firstName) {
  const who = firstName || 'this patient';
  return (
    `${OPENER}${who} for today's visit from their history, this visit so far and connected-app data (this visit and earlier ones). ` +
    'Under 120 words, exactly this shape:\n' +
    "**Today's focus:** one sentence.\n" +
    '**Action items**\n' +
    '- [ ] at most 5, most important first, each under 12 words, ending with its source in italics: _(this visit)_, _(history)_ or _(<app name>)_\n' +
    '**Watch for:** one line of precautions or red flags — leave it out if there are none.\n' +
    "Only what's in the record; skip anything you don't have."
  );
}

/** The thread shows this ask as a chip, not the instructions above. */
export const isSummaryPrompt = (text) => typeof text === 'string' && text.startsWith(OPENER) && text.includes('**Action items**');
